import { Controller } from "@hotwired/stimulus"

// Meeting item form controller (MVP). Decision and Action items share a
// single "Owner + Date" row, revealed only for those two kinds. The
// backend maps Owner/Date onto the right columns by kind, so the form
// payload stays the same regardless.
export default class extends Controller {
  static targets = ["kind", "ownerRow", "actionNotice", "sectionLabel"]

  // Maps the item kind to its minutes-section label (mirrors
  // MeetingItem::KIND_LABELS) so the form shows which section it adds to.
  static SECTION_LABELS = {
    decision: "Decisions Made",
    action: "Action Items",
    discussion: "Key Discussion Points",
    risk: "Open Issues / Risks",
    next_step: "Next Steps",
    informational: "Key Discussion Points"
  }

  connect() {
    this.updateVisibility()
  }

  updateVisibility() {
    const kind = this.hasKindTarget ? this.kindTarget.value : "discussion"
    const needsOwner = kind === "decision" || kind === "action"
    const isAction = kind === "action"

    if (this.hasOwnerRowTarget) {
      this.ownerRowTarget.classList.toggle("hidden", !needsOwner)
    }
    if (this.hasActionNoticeTarget) {
      this.actionNoticeTarget.classList.toggle("hidden", !isAction)
    }
    if (this.hasSectionLabelTarget) {
      this.sectionLabelTarget.textContent =
        this.constructor.SECTION_LABELS[kind] || "Key Discussion Points"
    }
  }
}
